import React, { useEffect, useState } from "react";
import { Tag, Flex } from "antd";
import { Error, Success } from "../../../commons/Messages/Messages";
import axios from "axios";
import DeleteModal from "../../../commons/DeleteModal/DeleteModal";
import AddDeals from "./AddDeals";
import UpdateDeals from "./UpdateDeals";
import GeneralTable from "../../../commons/GeneralTable";
import DropdownComp from "../../../commons/Dropdowns/DropdownComp";
import SearchBarComp from "../../../commons/SearchBar/SearchBar";
import PageToolbar from "../../../design-system/PageToolbar";
import dayjs from "dayjs";

import { useTranslation } from "react-i18next";
const ServiceProviderDeals = () => {
  const { t } = useTranslation("dashboard");
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [totalCount, setTotalCount] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(9);
  const [data, setData] = useState([
    // {
    //   _id: "qjwdn329e3",
    //   title: t("New Deal 1"),
    //   stage: "Conversation",
    //   value: "1000",
    //   tags: ["tag1", "tag2"],
    //   employee: {
    //     firstName: "Saeed",
    //     lastName: "Ahmed",
    //     _id: "1293uwiqdws"
    //   },
    //   client: {
    //     firstName: "Saeed",
    //     lastName: "Ahmed",
    //     _id: "1293uwiqdws"
    //   },
    //   serviceProvider: {
    //     _id: "1293uwiqdws"
    //   },
    //   probability: "Laptop",
    //   startDate: "2024-07-01",
    //   closeDate: "2024-07-15",
    //   priority: "Low",
    //   notes: "....",
    //   createdBy: {
    //     firstName: "Saeed",
    //     _id: "1293uwiqdws"
    //   },
    //   status: "Active"
    // },
    // {
    //   _id: "qjwdn329e3",
    //   title: t("Deal 2"),
    //   stage: "Pipeline",
    //   value: "10000",
    //   tags: ["tag1", "tag2"],
    //   employee: {
    //     firstName: "Saeed",
    //     lastName: "Ahmed",
    //     _id: "1293uwiqdws"
    //   },
    //   client: {
    //     firstName: "Saeed",
    //     lastName: "Ahmed",
    //     _id: "1293uwiqdws"
    //   },
    //   serviceProvider: {
    //     _id: "1293uwiqdws"
    //   },
    //   probability: "Laptop",
    //   startDate: "2024-07-01",
    //   closeDate: "2024-07-15",
    //   priority: "High",
    //   notes: "....",
    //   createdBy: {
    //     firstName: "Saeed",
    //     _id: "1293uwiqdws"
    //   },
    //   status: "In Process"
    // }
  ]);

  const getData = async () => {};

  const deleteHandler = async id => {
    await axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/deals/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          getData();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        Error(err.message);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      title: "#",
      dataIndex: "_id",
      mobile: "hidden",
      render: (text, record, index) => index + 1
    },
    {
      title: t("Title"),
      dataIndex: "title",
      mobile: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
      render: title => title
    },
    {
      title: t("Stage"),
      dataIndex: "stage",
      mobile: "subtitle",
      sorter: (a, b) => a.stage.localeCompare(b.stage)
    },
    {
      title: t("Value"),
      dataIndex: "value",
      sorter: (a, b) => a.value - b?.value
    },
    {
      title: t("Taken By"),
      dataIndex: "employee",
      sorter: (a, b) => a.employee?.firstName?.localeCompare(b?.employee?.firstName),
      render: employee => employee?.firstName + " " + employee?.lastName
    },
    {
      title: t("Client"),
      dataIndex: "client",
      sorter: (a, b) => a.client?.firstName?.localeCompare(b?.client?.firstName),
      render: (text, data) => data?.client?.firstName + " " + data?.client?.lastName
    },
    {
      title: t("Start Date"),
      dataIndex: "startDate",
      render: text => dayjs(text).format("DD/MMM/YYYY"),
      sorter: (a, b) =>
        dayjs(a?.startDate).format("DD/MMM/YYYY") - dayjs(b?.startDate).format("DD/MMM/YYYY")
    },
    {
      title: t("Close Date"),
      dataIndex: "closeDate",
      render: text => dayjs(text).format("DD/MMM/YYYY"),
      sorter: (a, b) =>
        dayjs(a?.closeDate).format("DD/MMM/YYYY") - dayjs(b?.closeDate).format("DD/MMM/YYYY")
    },
    {
      title: t("Status"),
      dataIndex: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: status => <div>{status}</div>
    },
    {
      title: t("Priority"),
      dataIndex: "priority",
      sorter: (a, b) => a.priority.localeCompare(b.priority),
      render: priority => <div>{priority}</div>
    },
    {
      title: t("Tags"),
      dataIndex: "tags",
      render: (text, obj) => (
        <Flex wrap gap={4}>
          {obj?.tags?.map((tag, index) => (
            <Tag key={index}>{tag}</Tag>
          ))}
        </Flex>
      )
    },
    {
      title: t("Notes"),
      dataIndex: "notes",
      mobile: "hidden"
    },
    {
      title: t("Action"),
      key: "action",
      mobile: "actions",
      render: (text, obj) => {
        const menuItems = [
          {
            key: "view",
            link: `/user/deals/23213`
          },
          {
            key: "edit",
            component: () => <UpdateDeals data={obj} updateParent={getData} />
          },
          {
            key: "delete",
            component: () => <DeleteModal text="Deal" onClick={() => deleteHandler(obj?._id)} />
          }
        ];
        return (
          <div>
            <DropdownComp menuItems={menuItems} />
          </div>
        );
      }
    }
  ];

  const handleSearch = val => {
    setSearchText(val);
  };

  return (
    <div className="deals-page">
      <PageToolbar
        filters={<SearchBarComp handleSearch={handleSearch} />}
        actions={<AddDeals updateParent={getData} />}
      />
      <GeneralTable
        pageNo={pageNo}
        pageSize={pageSize}
        totalCount={totalCount}
        data={data}
        columns={columns}
        setPageNo={setPageNo}
      />
    </div>
  );
};

export default ServiceProviderDeals;
